// Ant Design Select/TreeSelect uses ResizeObserver internally.
// Rapid checkbox toggles can trigger a benign browser warning that CRA's dev
// overlay surfaces as a fatal error. Defer callbacks to the next frame.
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer)
        })
      })
    }
  }
}

const RESIZE_OBSERVER_LOOP = 'ResizeObserver loop'

const suppressResizeObserverOverlay = (event) => {
  const message = event?.message || event?.reason?.message || ''
  if (message.includes(RESIZE_OBSERVER_LOOP)) {
    event.stopImmediatePropagation?.()
    event.preventDefault?.()
    return true
  }
  return false
}

window.addEventListener('error', suppressResizeObserverOverlay)

const originalOnError = window.onerror
window.onerror = function onError(message, source, lineno, colno, error) {
  if (String(message).includes(RESIZE_OBSERVER_LOOP)) {
    return true
  }
  if (typeof originalOnError === 'function') {
    return originalOnError.call(this, message, source, lineno, colno, error)
  }
  return false
}
